import { cn } from '@/utilities/ui'

/*
  Color should be the hsl variable name in globals.css
  Example: card, background, foreground, etc.
*/
type DotsBackgroundProps = {
  color?: string
  className?: string
  svgClassName?: string
}

export const DotsBackground: React.FC<DotsBackgroundProps> = (props: DotsBackgroundProps) => {
  const { className, color = 'var(--card)', svgClassName } = props
  return (
    <div
      className={cn(
        'pointer-events-none absolute inset-0 z-0 flex size-full items-center justify-center overflow-hidden',
        className,
      )}
    >
      {/* Mask gradients */}
      {/* Top mask */}
      <div
        className="absolute top-0 left-0 z-2 h-1/4 w-full"
        style={{
          background: `linear-gradient(to bottom, hsl(${color}) 25%, transparent 100%)`,
        }}
      />
      {/* Bottom mask */}
      <div
        className="absolute bottom-0 left-0 z-2 h-1/4 w-full"
        style={{
          background: `linear-gradient(to top, hsl(${color}) 25%, transparent 100%)`,
        }}
      />
      {/* Left mask */}
      <div
        className="absolute top-0 left-0 z-2 h-full w-1/4"
        style={{
          background: `linear-gradient(to right, hsl(${color}) 25%, transparent 100%)`,
        }}
      />
      {/* Right mask */}
      <div
        className="absolute top-0 right-0 z-2 h-full w-1/4"
        style={{
          background: `linear-gradient(to left, hsl(${color}) 25%, transparent 100%)`,
        }}
      />
      <svg
        width="726"
        height="440"
        viewBox="0 0 726 440"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn('relative z-1 translate-8 scale-105', svgClassName)}
        role="presentation"
      >
        <path
          d="M190.435 432.616C188.92 432.616 187.69 433.842 187.69 435.361C187.69 436.875 188.92 438.101 190.435 438.101C191.949 438.101 193.177 436.875 193.177 435.361C193.177 433.842 191.949 432.616 190.435 432.616Z"
          fill="#FAFAFA"
        />
        <path
          d="M190.435 363.852C184.888 363.852 180.391 368.352 180.391 373.899C180.391 379.448 184.888 383.94 190.435 383.94C195.982 383.94 200.48 379.448 200.48 373.899C200.48 368.352 195.982 363.852 190.435 363.852Z"
          fill="#FAFAFA"
        />
        <path
          d="M190.435 397.501C186.498 397.501 183.307 400.695 183.307 404.63C183.307 408.564 186.498 411.752 190.435 411.752C194.37 411.752 197.561 408.564 197.561 404.63C197.561 400.695 194.37 397.501 190.435 397.501Z"
          fill="#FAFAFA"
        />
        <path
          d="M221.167 38.8415C222.82 38.8415 224.16 37.5045 224.16 35.8485C224.16 34.1915 222.82 32.8555 221.167 32.8555C219.513 32.8555 218.175 34.1915 218.175 35.8485C218.175 37.5045 219.513 38.8415 221.167 38.8415Z"
          fill="#FAFAFA"
        />
        <path
          d="M190.435 330.556C183.47 330.556 177.825 336.201 177.825 343.168C177.825 350.129 183.47 355.775 190.435 355.775C197.398 355.775 203.043 350.129 203.043 343.168C203.043 336.201 197.398 330.556 190.435 330.556Z"
          fill="#F5F5F5"
        />
        <path
          d="M190.435 298.541C182.765 298.541 176.541 304.76 176.541 312.43C176.541 320.105 182.765 326.33 190.435 326.33C198.106 326.33 204.327 320.105 204.327 312.43C204.327 304.76 198.106 298.541 190.435 298.541Z"
          fill="#F5F5F5"
        />
        <path
          d="M344.092 140.151C350.781 140.151 356.205 134.733 356.205 128.042C356.205 121.358 350.781 115.934 344.092 115.934C337.404 115.934 331.983 121.358 331.983 128.042C331.983 134.733 337.404 140.151 344.092 140.151Z"
          fill="#E5E5E5"
        />
        <path
          d="M190.435 226.223C193.741 226.223 196.418 223.543 196.418 220.236C196.418 216.934 193.741 214.254 190.435 214.254C187.129 214.254 184.45 216.934 184.45 220.236C184.45 223.543 187.129 226.223 190.435 226.223Z"
          fill="#F5F5F5"
        />
        <path
          d="M221.167 7.04345C222.229 7.04345 223.091 6.17745 223.091 5.11646C223.091 4.05546 222.229 3.18945 221.167 3.18945C220.102 3.18945 219.241 4.05546 219.241 5.11646C219.241 6.17745 220.102 7.04345 221.167 7.04345Z"
          fill="#FAFAFA"
        />
        <path
          d="M190.435 293.602C197.003 293.602 202.332 288.27 202.332 281.704C202.332 275.134 197.003 269.807 190.435 269.807C183.865 269.807 178.534 275.134 178.534 281.704C178.534 288.27 183.865 293.602 190.435 293.602Z"
          fill="#F5F5F5"
        />
        <path
          d="M221.167 294.24C228.092 294.24 233.704 288.628 233.704 281.703C233.704 274.776 228.092 269.162 221.167 269.162C214.24 269.162 208.626 274.776 208.626 281.703C208.626 288.628 214.24 294.24 221.167 294.24Z"
          fill="#F5F5F5"
        />
        <path
          d="M190.435 160.414C191.342 160.414 192.072 159.677 192.072 158.774C192.072 157.87 191.342 157.14 190.435 157.14C189.531 157.14 188.798 157.87 188.798 158.774C188.798 159.677 189.531 160.414 190.435 160.414Z"
          fill="#F5F5F5"
        />
        <path
          d="M221.167 367.127C217.429 367.127 214.396 370.158 214.396 373.898C214.396 377.633 217.429 380.665 221.167 380.665C224.904 380.665 227.934 377.633 227.934 373.898C227.934 370.158 224.904 367.127 221.167 367.127Z"
          fill="#FAFAFA"
        />
        <path
          d="M128.972 164.121C131.924 164.121 134.314 161.73 134.314 158.774C134.314 155.83 131.924 153.43 128.972 153.43C126.019 153.43 123.628 155.83 123.628 158.774C123.628 161.73 126.019 164.121 128.972 164.121Z"
          fill="#F5F5F5"
        />
        <path
          d="M221.167 400.495C218.884 400.495 217.034 402.345 217.034 404.63C217.034 406.909 218.884 408.759 221.167 408.759C223.446 408.759 225.298 406.909 225.298 404.63C225.298 402.345 223.446 400.495 221.167 400.495Z"
          fill="#FAFAFA"
        />
        <path
          d="M221.167 225.08C223.842 225.08 226.013 222.917 226.013 220.237C226.013 217.563 223.842 215.392 221.167 215.392C218.49 215.392 216.319 217.563 216.319 220.237C216.319 222.917 218.49 225.08 221.167 225.08Z"
          fill="#C89A77"
        />
        <path
          d="M219.385 189.511C219.385 190.49 220.183 191.285 221.167 191.285C222.151 191.285 222.947 190.49 222.947 189.511C222.947 188.521 222.151 187.724 221.167 187.724C220.183 187.724 219.385 188.521 219.385 189.511Z"
          fill="#A8573E"
        />
        <path
          d="M224.016 97.3099C224.016 95.7349 222.738 94.4629 221.167 94.4629C219.593 94.4629 218.316 95.7349 218.316 97.3099C218.316 98.8849 219.593 100.163 221.167 100.163C222.738 100.163 224.016 98.8849 224.016 97.3099Z"
          fill="#F5F5F5"
        />
        <path
          d="M221.167 70.1406C223.133 70.1406 224.73 68.5496 224.73 66.5796C224.73 64.6136 223.133 63.0176 221.167 63.0176C219.198 63.0176 217.601 64.6136 217.601 66.5796C217.601 68.5496 219.198 70.1406 221.167 70.1406Z"
          fill="#F5F5F5"
        />
        <path
          d="M221.167 261.23C226.831 261.23 231.426 256.635 231.426 250.968C231.426 245.305 226.831 240.71 221.167 240.71C215.501 240.71 210.906 245.305 210.906 250.968C210.906 256.635 215.501 261.23 221.167 261.23Z"
          fill="#FAFAFA"
        />
        <path
          d="M128.972 261.013C134.52 261.013 139.016 256.516 139.016 250.968C139.016 245.425 134.52 240.926 128.972 240.926C123.423 240.926 118.926 245.425 118.926 250.968C118.926 256.516 123.423 261.013 128.972 261.013Z"
          fill="#F5F5F5"
        />
        <path
          d="M128.972 394.442C123.346 394.442 118.784 399 118.784 404.629C118.784 410.259 123.346 414.816 128.972 414.816C134.599 414.816 139.161 410.259 139.161 404.629C139.161 399 134.599 394.442 128.972 394.442Z"
          fill="#FAFAFA"
        />
        <path
          d="M128.972 297.826C120.906 297.826 114.364 304.364 114.364 312.43C114.364 320.501 120.906 327.039 128.972 327.039C137.037 327.039 143.578 320.501 143.578 312.43C143.578 304.364 137.037 297.826 128.972 297.826Z"
          fill="#FAFAFA"
        />
        <path
          d="M128.972 430.3C126.179 430.3 123.913 432.562 123.913 435.361C123.913 438.155 126.179 440.422 128.972 440.422C131.767 440.422 134.029 438.155 134.029 435.361C134.029 432.562 131.767 430.3 128.972 430.3Z"
          fill="#FAFAFA"
        />
        <path
          d="M128.972 361.146C121.926 361.146 116.215 366.857 116.215 373.899C116.215 380.941 121.926 386.646 128.972 386.646C136.017 386.646 141.721 380.941 141.721 373.899C141.721 366.857 136.017 361.146 128.972 361.146Z"
          fill="#FAFAFA"
        />
        <path
          d="M128.972 328.991C121.142 328.991 114.793 335.335 114.793 343.167C114.793 350.994 121.142 357.343 128.972 357.343C136.801 357.343 143.148 350.994 143.148 343.167C143.148 335.335 136.801 328.991 128.972 328.991Z"
          fill="#FAFAFA"
        />
        <path
          d="M159.703 197.131C163.911 197.131 167.326 193.715 167.326 189.51C167.326 185.298 163.911 181.883 159.703 181.883C155.491 181.883 152.08 185.298 152.08 189.51C152.08 193.715 155.491 197.131 159.703 197.131Z"
          fill="#F5F5F5"
        />
        <path
          d="M128.972 230.282C134.52 230.282 139.016 225.783 139.016 220.236C139.016 214.692 134.52 210.195 128.972 210.195C123.423 210.195 118.926 214.692 118.926 220.236C118.926 225.783 123.423 230.282 128.972 230.282Z"
          fill="#F5F5F5"
        />
        <path
          d="M128.972 294.381C135.972 294.381 141.654 288.708 141.654 281.703C141.654 274.699 135.972 269.022 128.972 269.022C121.967 269.022 116.289 274.699 116.289 281.703C116.289 288.708 121.967 294.381 128.972 294.381Z"
          fill="#F5F5F5"
        />
        <path
          d="M128.972 198.554C133.97 198.554 138.018 194.501 138.018 189.51C138.018 184.508 133.97 180.46 128.972 180.46C123.976 180.46 119.924 184.508 119.924 189.51C119.924 194.501 123.976 198.554 128.972 198.554Z"
          fill="#F5F5F5"
        />
        <path
          d="M221.167 332.91C215.501 332.91 210.906 337.5 210.906 343.167C210.906 348.83 215.501 353.423 221.167 353.423C226.831 353.423 231.426 348.83 231.426 343.167C231.426 337.5 226.831 332.91 221.167 332.91Z"
          fill="#F5F5F5"
        />
        <path
          d="M159.703 329.057C151.913 329.057 145.596 335.374 145.596 343.168C145.596 350.957 151.913 357.275 159.703 357.275C167.492 357.275 173.809 350.957 173.809 343.168C173.809 335.374 167.492 329.057 159.703 329.057Z"
          fill="#F5F5F5"
        />
        <path
          d="M159.703 361.216C152.699 361.216 147.02 366.894 147.02 373.897C147.02 380.902 152.699 386.58 159.703 386.58C166.705 386.58 172.385 380.902 172.385 373.897C172.385 366.894 166.705 361.216 159.703 361.216Z"
          fill="#FAFAFA"
        />
        <path
          d="M159.703 431.257C157.437 431.257 155.601 433.093 155.601 435.361C155.601 437.63 157.437 439.465 159.703 439.465C161.968 439.465 163.804 437.63 163.804 435.361C163.804 433.093 161.968 431.257 159.703 431.257Z"
          fill="#FAFAFA"
        />
        <path
          d="M190.435 193.352C192.559 193.352 194.28 191.632 194.28 189.51C194.28 187.383 192.559 185.661 190.435 185.661C188.309 185.661 186.588 187.383 186.588 189.51C186.588 191.632 188.309 193.352 190.435 193.352Z"
          fill="#E5E5E5"
        />
        <path
          d="M159.703 394.87C154.312 394.87 149.941 399.239 149.941 404.629C149.941 410.015 154.312 414.39 159.703 414.39C165.09 414.39 169.462 410.015 169.462 404.629C169.462 399.239 165.09 394.87 159.703 394.87Z"
          fill="#FAFAFA"
        />
        <path
          d="M159.703 293.386C166.153 293.386 171.386 288.157 171.386 281.704C171.386 275.254 166.153 270.019 159.703 270.019C153.251 270.019 148.019 275.254 148.019 281.704C148.019 288.157 153.251 293.386 159.703 293.386Z"
          fill="#FAFAFA"
        />
        <path
          d="M159.703 229.145C164.62 229.145 168.609 225.156 168.609 220.236C168.609 215.321 164.62 211.332 159.703 211.332C154.785 211.332 150.796 215.321 150.796 220.236C150.796 225.156 154.785 229.145 159.703 229.145Z"
          fill="#F5F5F5"
        />
        <path
          d="M159.703 297.974C151.714 297.974 145.241 304.447 145.241 312.431C145.241 320.42 151.714 326.893 159.703 326.893C167.69 326.893 174.163 320.42 174.163 312.431C174.163 304.447 167.69 297.974 159.703 297.974Z"
          fill="#FAFAFA"
        />
        <path
          d="M159.703 242.351C154.942 242.351 151.083 246.21 151.083 250.969C151.083 255.732 154.942 259.591 159.703 259.591C164.464 259.591 168.324 255.732 168.324 250.969C168.324 246.21 164.464 242.351 159.703 242.351Z"
          fill="#F5F5F5"
        />
        <path
          d="M159.703 162.48C161.751 162.48 163.408 160.82 163.408 158.773C163.408 156.726 161.751 155.07 159.703 155.07C157.66 155.07 155.998 156.726 155.998 158.773C155.998 160.82 157.66 162.48 159.703 162.48Z"
          fill="#F5F5F5"
        />
        <path
          d="M221.167 299.396C213.964 299.396 208.132 305.231 208.132 312.431C208.132 319.636 213.964 325.471 221.167 325.471C228.368 325.471 234.203 319.636 234.203 312.431C234.203 305.231 228.368 299.396 221.167 299.396Z"
          fill="#F5F5F5"
        />
        <path
          d="M313.363 138.299C319.03 138.299 323.619 133.709 323.619 128.041C323.619 122.379 319.03 117.783 313.363 117.783C307.696 117.783 303.103 122.379 303.103 128.041C303.103 133.709 307.696 138.299 313.363 138.299Z"
          fill="#F5F5F5"
        />
        <path
          d="M313.363 104.651C317.414 104.651 320.697 101.365 320.697 97.3106C320.697 93.2556 317.414 89.9756 313.363 89.9756C309.309 89.9756 306.022 93.2556 306.022 97.3106C306.022 101.365 309.309 104.651 313.363 104.651Z"
          fill="#E5E5E5"
        />
        <path
          d="M313.363 148.728C307.815 148.728 303.316 153.227 303.316 158.774C303.316 164.322 307.815 168.821 313.363 168.821C318.909 168.821 323.406 164.322 323.406 158.774C323.406 153.227 318.909 148.728 313.363 148.728Z"
          fill="#E5E5E5"
        />
        <path
          d="M282.631 270.375C276.374 270.375 271.302 275.446 271.302 281.703C271.302 287.957 276.374 293.027 282.631 293.027C288.883 293.027 293.958 287.957 293.958 281.703C293.958 275.446 288.883 270.375 282.631 270.375Z"
          fill="#F5F5F5"
        />
        <path
          d="M313.363 181.028C308.681 181.028 304.884 184.822 304.884 189.51C304.884 194.187 308.681 197.986 313.363 197.986C318.046 197.986 321.839 194.187 321.839 189.51C321.839 184.822 318.046 181.028 313.363 181.028Z"
          fill="#243C2F"
        />
        <path
          d="M313.363 70.2103C315.369 70.2103 316.995 68.5873 316.995 66.5793C316.995 64.5713 315.369 62.9463 313.363 62.9463C311.355 62.9463 309.729 64.5713 309.729 66.5793C309.729 68.5873 311.355 70.2103 313.363 70.2103Z"
          fill="#F5F5F5"
        />
        <path
          d="M282.631 304.029C277.987 304.029 274.226 307.791 274.226 312.43C274.226 317.074 277.987 320.841 282.631 320.841C287.27 320.841 291.037 317.074 291.037 312.43C291.037 307.791 287.27 304.029 282.631 304.029Z"
          fill="#F5F5F5"
        />
        <path
          d="M282.631 340.243C281.018 340.243 279.709 341.554 279.709 343.167C279.709 344.774 281.018 346.089 282.631 346.089C284.244 346.089 285.551 344.774 285.551 343.167C285.551 341.554 284.244 340.243 282.631 340.243Z"
          fill="#F5F5F5"
        />
        <path
          d="M313.363 212.686C309.192 212.686 305.809 216.069 305.809 220.237C305.809 224.411 309.192 227.788 313.363 227.788C317.53 227.788 320.913 224.411 320.913 220.237C320.913 216.069 317.53 212.686 313.363 212.686Z"
          fill="#50818A"
        />
        <path
          d="M315.925 343.168C315.925 341.75 314.779 340.603 313.363 340.603C311.945 340.603 310.798 341.75 310.798 343.168C310.798 344.58 311.945 345.735 313.363 345.735C314.779 345.735 315.925 344.58 315.925 343.168Z"
          fill="#E5E5E5"
        />
        <path
          d="M344.092 106.858C349.367 106.858 353.639 102.583 353.639 97.3106C353.639 92.0376 349.367 87.7676 344.092 87.7676C338.822 87.7676 334.546 92.0376 334.546 97.3106C334.546 102.583 338.822 106.858 344.092 106.858Z"
          fill="#243C2F"
        />
        <path
          d="M313.363 304.81C309.154 304.81 305.738 308.224 305.738 312.431C305.738 316.643 309.154 320.058 313.363 320.058C317.571 320.058 320.985 316.643 320.985 312.431C320.985 308.224 317.571 304.81 313.363 304.81Z"
          fill="#F5F5F5"
        />
        <path
          d="M344.092 70.779C346.414 70.779 348.294 68.901 348.294 66.579C348.294 64.256 346.414 62.373 344.092 62.373C341.773 62.373 339.888 64.256 339.888 66.579C339.888 68.901 341.773 70.779 344.092 70.779Z"
          fill="#E5E5E5"
        />
        <path
          d="M313.363 261.301C319.068 261.301 323.69 256.678 323.69 250.969C323.69 245.268 319.068 240.641 313.363 240.641C307.658 240.641 303.032 245.268 303.032 250.969C303.032 256.678 307.658 261.301 313.363 261.301Z"
          fill="#E5E5E5"
        />
        <path
          d="M313.363 270.728C307.301 270.728 302.391 275.642 302.391 281.704C302.391 287.761 307.301 292.677 313.363 292.677C319.423 292.677 324.333 287.761 324.333 281.704C324.333 275.642 319.423 270.728 313.363 270.728Z"
          fill="#C89A77"
        />
        <path
          d="M251.9 124.48C249.929 124.48 248.336 126.076 248.336 128.041C248.336 130.012 249.929 131.603 251.9 131.603C253.865 131.603 255.462 130.012 255.462 128.041C255.462 126.076 253.865 124.48 251.9 124.48Z"
          fill="#F5F5F5"
        />
        <path
          d="M251.9 225.649C254.889 225.649 257.312 223.229 257.312 220.236C257.312 217.247 254.889 214.823 251.9 214.823C248.909 214.823 246.481 217.247 246.481 220.236C246.481 223.229 248.909 225.649 251.9 225.649Z"
          fill="#A8573E"
        />
        <path
          d="M251.9 92.6123C249.302 92.6123 247.196 94.7123 247.196 97.3103C247.196 99.9083 249.302 102.013 251.9 102.013C254.496 102.013 256.599 99.9083 256.599 97.3103C256.599 94.7123 254.496 92.6123 251.9 92.6123Z"
          fill="#F5F5F5"
        />
        <path
          d="M251.9 269.374C245.093 269.374 239.576 274.899 239.576 281.703C239.576 288.508 245.093 294.029 251.9 294.029C258.704 294.029 264.226 288.508 264.226 281.703C264.226 274.899 258.704 269.374 251.9 269.374Z"
          fill="#F5F5F5"
        />
        <path
          d="M251.9 261.728C257.838 261.728 262.656 256.91 262.656 250.968C262.656 245.029 257.838 240.211 251.9 240.211C245.957 240.211 241.139 245.029 241.139 250.968C241.139 256.91 245.957 261.728 251.9 261.728Z"
          fill="#F5F5F5"
        />
        <path
          d="M251.9 39.9778C254.178 39.9778 256.03 38.1318 256.03 35.8478C256.03 33.5628 254.178 31.7178 251.9 31.7178C249.616 31.7178 247.764 33.5628 247.764 35.8478C247.764 38.1318 249.616 39.9778 251.9 39.9778Z"
          fill="#F5F5F5"
        />
        <path
          d="M251.9 337.182C248.593 337.182 245.914 339.86 245.914 343.168C245.914 346.469 248.593 349.15 251.9 349.15C255.202 349.15 257.882 346.469 257.882 343.168C257.882 339.86 255.202 337.182 251.9 337.182Z"
          fill="#F5F5F5"
        />
        <path
          d="M251.9 186.37C250.168 186.37 248.764 187.778 248.764 189.51C248.764 191.236 250.168 192.639 251.9 192.639C253.633 192.639 255.034 191.236 255.034 189.51C255.034 187.778 253.633 186.37 251.9 186.37Z"
          fill="#E5E5E5"
        />
        <path
          d="M251.9 7.25452C253.08 7.25452 254.032 6.29652 254.032 5.11652C254.032 3.93752 253.08 2.97852 251.9 2.97852C250.718 2.97852 249.761 3.93752 249.761 5.11652C249.761 6.29652 250.718 7.25452 251.9 7.25452Z"
          fill="#F5F5F5"
        />
        <path
          d="M251.9 71.6394C254.692 71.6394 256.958 69.3714 256.958 66.5794C256.958 63.7864 254.692 61.5234 251.9 61.5234C249.104 61.5234 246.839 63.7864 246.839 66.5794C246.839 69.3714 249.104 71.6394 251.9 71.6394Z"
          fill="#F5F5F5"
        />
        <path
          d="M251.9 155.569C250.127 155.569 248.693 157.003 248.693 158.773C248.693 160.543 250.127 161.976 251.9 161.976C253.67 161.976 255.105 160.543 255.105 158.773C255.105 157.003 253.67 155.569 251.9 155.569Z"
          fill="#F5F5F5"
        />
        <path
          d="M282.631 102.941C285.739 102.941 288.257 100.418 288.257 97.3107C288.257 94.2037 285.739 91.6807 282.631 91.6807C279.521 91.6807 277.001 94.2037 277.001 97.3107C277.001 100.418 279.521 102.941 282.631 102.941Z"
          fill="#F5F5F5"
        />
        <path
          d="M282.631 166.253C286.76 166.253 290.112 162.909 290.112 158.773C290.112 154.642 286.76 151.292 282.631 151.292C278.498 151.292 275.148 154.642 275.148 158.773C275.148 162.909 278.498 166.253 282.631 166.253Z"
          fill="#F5F5F5"
        />
        <path
          d="M282.631 226.721C286.21 226.721 289.114 223.818 289.114 220.236C289.114 216.658 286.21 213.755 282.631 213.755C279.048 213.755 276.147 216.658 276.147 220.236C276.147 223.818 279.048 226.721 282.631 226.721Z"
          fill="#6A835E"
        />
        <path
          d="M251.9 371.332C250.481 371.332 249.335 372.481 249.335 373.897C249.335 375.311 250.481 376.464 251.9 376.464C253.315 376.464 254.462 375.311 254.462 373.897C254.462 372.481 253.315 371.332 251.9 371.332Z"
          fill="#F5F5F5"
        />
        <path
          d="M282.631 135.025C286.485 135.025 289.615 131.895 289.615 128.041C289.615 124.188 286.485 121.063 282.631 121.063C278.777 121.063 275.648 124.188 275.648 128.041C275.648 131.895 278.777 135.025 282.631 135.025Z"
          fill="#F5F5F5"
        />
        <path
          d="M282.631 195.92C286.168 195.92 289.04 193.045 289.04 189.511C289.04 185.964 286.168 183.097 282.631 183.097C279.09 183.097 276.217 185.964 276.217 189.511C276.217 193.045 279.09 195.92 282.631 195.92Z"
          fill="#F5F5F5"
        />
        <path
          d="M251.9 301.744C245.997 301.744 241.213 306.53 241.213 312.43C241.213 318.335 245.997 323.121 251.9 323.121C257.799 323.121 262.585 318.335 262.585 312.43C262.585 306.53 257.799 301.744 251.9 301.744Z"
          fill="#F5F5F5"
        />
        <path
          d="M282.631 70.8506C284.992 70.8506 286.904 68.9386 286.904 66.5796C286.904 64.2186 284.992 62.3086 282.631 62.3086C280.27 62.3086 278.356 64.2186 278.356 66.5796C278.356 68.9386 280.27 70.8506 282.631 70.8506Z"
          fill="#F5F5F5"
        />
        <path
          d="M282.631 261.159C288.256 261.159 292.818 256.597 292.818 250.968C292.818 245.343 288.256 240.781 282.631 240.781C277.004 240.781 272.442 245.343 272.442 250.968C272.442 256.597 277.004 261.159 282.631 261.159Z"
          fill="#C89A77"
        />
        <path
          d="M282.631 38.4122C284.047 38.4122 285.193 37.2662 285.193 35.8482C285.193 34.4292 284.047 33.2822 282.631 33.2822C281.214 33.2822 280.065 34.4292 280.065 35.8482C280.065 37.2662 281.214 38.4122 282.631 38.4122Z"
          fill="#F5F5F5"
        />
        <path
          d="M190.434 259.731C195.276 259.731 199.2 255.807 199.2 250.968C199.2 246.133 195.276 242.209 190.434 242.209C185.596 242.209 181.675 246.133 181.675 250.968C181.675 255.807 185.596 259.731 190.434 259.731Z"
          fill="#F5F5F5"
        />
        <path
          d="M6.04205 231.494C12.2611 231.494 17.301 226.455 17.301 220.236C17.301 214.021 12.2611 208.982 6.04205 208.982C-0.171947 208.982 -5.20996 214.021 -5.20996 220.236C-5.20996 226.455 -0.171947 231.494 6.04205 231.494Z"
          fill="#FAFAFA"
        />
        <path
          d="M6.0434 69.2841C7.5394 69.2841 8.74939 68.0731 8.74939 66.5791C8.74939 65.0851 7.5394 63.8721 6.0434 63.8721C4.5494 63.8721 3.3374 65.0851 3.3374 66.5791C3.3374 68.0731 4.5494 69.2841 6.0434 69.2841Z"
          fill="#FAFAFA"
        />
        <path
          d="M6.04323 136.449C10.6882 136.449 14.4492 132.687 14.4492 128.042C14.4492 123.404 10.6882 119.637 6.04323 119.637C1.40223 119.637 -2.36377 123.404 -2.36377 128.042C-2.36377 132.687 1.40223 136.449 6.04323 136.449Z"
          fill="#FAFAFA"
        />
        <path
          d="M6.04231 199.481C11.5523 199.481 16.0183 195.02 16.0183 189.51C16.0183 184 11.5523 179.534 6.04231 179.534C0.533313 179.534 -3.92969 184 -3.92969 189.51C-3.92969 195.02 0.533313 199.481 6.04231 199.481Z"
          fill="#FAFAFA"
        />
        <path
          d="M6.04225 168.396C11.3593 168.396 15.6632 164.084 15.6632 158.773C15.6632 153.463 11.3593 149.159 6.04225 149.159C0.732252 149.159 -3.57275 153.463 -3.57275 158.773C-3.57275 164.084 0.732252 168.396 6.04225 168.396Z"
          fill="#FAFAFA"
        />
        <path
          d="M6.04207 102.793C9.07507 102.793 11.5311 100.341 11.5311 97.3103C11.5311 94.2783 9.07507 91.8213 6.04207 91.8213C3.01207 91.8213 0.560059 94.2783 0.560059 97.3103C0.560059 100.341 3.01207 102.793 6.04207 102.793Z"
          fill="#FAFAFA"
        />
        <path
          d="M128.972 99.0206C129.916 99.0206 130.682 98.2576 130.682 97.3106C130.682 96.3686 129.916 95.5996 128.972 95.5996C128.027 95.5996 127.261 96.3686 127.261 97.3106C127.261 98.2576 128.027 99.0206 128.972 99.0206Z"
          fill="#F5F5F5"
        />
        <path
          d="M6.04243 237.225C-1.55157 237.225 -7.70557 243.379 -7.70557 250.969C-7.70557 258.563 -1.55157 264.722 6.04243 264.722C13.6374 264.722 19.7944 258.563 19.7944 250.969C19.7944 243.379 13.6374 237.225 6.04243 237.225Z"
          fill="#FAFAFA"
        />
        <path
          d="M98.2404 68.5052C99.3004 68.5052 100.162 67.6442 100.162 66.5792C100.162 65.5172 99.3004 64.6572 98.2404 64.6572C97.1764 64.6572 96.3164 65.5172 96.3164 66.5792C96.3164 67.6442 97.1764 68.5052 98.2404 68.5052Z"
          fill="#F5F5F5"
        />
        <path
          d="M98.2402 101.018C100.284 101.018 101.945 99.3564 101.945 97.3104C101.945 95.2684 100.284 93.6084 98.2402 93.6084C96.1902 93.6084 94.5352 95.2684 94.5352 97.3104C94.5352 99.3564 96.1902 101.018 98.2402 101.018Z"
          fill="#F5F5F5"
        />
        <path
          d="M98.2403 133.313C101.152 133.313 103.51 130.953 103.51 128.041C103.51 125.129 101.152 122.775 98.2403 122.775C95.3273 122.775 92.9683 125.129 92.9683 128.041C92.9683 130.953 95.3273 133.313 98.2403 133.313Z"
          fill="#F5F5F5"
        />
        <path
          d="M67.5082 262.796C74.0402 262.796 79.3352 257.502 79.3352 250.969C79.3352 244.44 74.0402 239.146 67.5082 239.146C60.9752 239.146 55.6782 244.44 55.6782 250.969C55.6782 257.502 60.9752 262.796 67.5082 262.796Z"
          fill="#FAFAFA"
        />
        <path
          d="M67.5082 299.396C60.3072 299.396 54.4692 305.231 54.4692 312.431C54.4692 319.636 60.3072 325.471 67.5082 325.471C74.7082 325.471 80.5423 319.636 80.5423 312.431C80.5423 305.231 74.7082 299.396 67.5082 299.396Z"
          fill="#F5F5F5"
        />
        <path
          d="M67.5082 365.774C63.0222 365.774 59.3862 369.411 59.3862 373.898C59.3862 378.385 63.0222 382.018 67.5082 382.018C71.9932 382.018 75.6302 378.385 75.6302 373.898C75.6302 369.411 71.9932 365.774 67.5082 365.774Z"
          fill="#F5F5F5"
        />
        <path
          d="M67.5082 268.519C60.2282 268.519 54.3252 274.424 54.3252 281.704C54.3252 288.985 60.2282 294.886 67.5082 294.886C74.7872 294.886 80.6902 288.985 80.6902 281.704C80.6902 274.424 74.7872 268.519 67.5082 268.519Z"
          fill="#FAFAFA"
        />
        <path
          d="M98.2404 199.41C103.709 199.41 108.143 194.977 108.143 189.51C108.143 184.038 103.709 179.604 98.2404 179.604C92.7714 179.604 88.3374 184.038 88.3374 189.51C88.3374 194.977 92.7714 199.41 98.2404 199.41Z"
          fill="#F5F5F5"
        />
        <path
          d="M67.5084 332.266C61.4874 332.266 56.6084 337.144 56.6084 343.168C56.6084 349.187 61.4874 354.064 67.5084 354.064C73.5274 354.064 78.4074 349.187 78.4074 343.168C78.4074 337.144 73.5274 332.266 67.5084 332.266Z"
          fill="#F5F5F5"
        />
        <path
          d="M67.5081 400.283C65.1081 400.283 63.1621 402.226 63.1621 404.629C63.1621 407.027 65.1081 408.977 67.5081 408.977C69.9091 408.977 71.8511 407.027 71.8511 404.629C71.8511 402.226 69.9091 400.283 67.5081 400.283Z"
          fill="#FAFAFA"
        />
        <path
          d="M98.24 166.325C102.411 166.325 105.788 162.946 105.788 158.774C105.788 154.607 102.411 151.224 98.24 151.224C94.07 151.224 90.687 154.607 90.687 158.774C90.687 162.946 94.07 166.325 98.24 166.325Z"
          fill="#F5F5F5"
        />
        <path
          d="M98.24 329.84C90.881 329.84 84.916 335.811 84.916 343.167C84.916 350.523 90.881 356.487 98.24 356.487C105.599 356.487 111.561 350.523 111.561 343.167C111.561 335.811 105.599 329.84 98.24 329.84Z"
          fill="#FAFAFA"
        />
        <path
          d="M98.2404 362.641C92.0244 362.641 86.9824 367.685 86.9824 373.899C86.9824 380.113 92.0244 385.153 98.2404 385.153C104.455 385.153 109.496 380.113 109.496 373.899C109.496 367.685 104.455 362.641 98.2404 362.641Z"
          fill="#FAFAFA"
        />
        <path
          d="M98.2403 230.427C103.867 230.427 108.427 225.865 108.427 220.236C108.427 214.612 103.867 210.049 98.2403 210.049C92.6123 210.049 88.0503 214.612 88.0503 220.236C88.0503 225.865 92.6123 230.427 98.2403 230.427Z"
          fill="#F5F5F5"
        />
        <path
          d="M98.237 431.938C96.346 431.938 94.814 433.474 94.814 435.365C94.814 437.257 96.346 438.785 98.237 438.785C100.127 438.785 101.66 437.257 101.66 435.365C101.66 433.474 100.127 431.938 98.237 431.938Z"
          fill="#FAFAFA"
        />
        <path
          d="M128.972 130.251C130.189 130.251 131.179 129.264 131.179 128.041C131.179 126.824 130.189 125.833 128.972 125.833C127.751 125.833 126.762 126.824 126.762 128.041C126.762 129.264 127.751 130.251 128.972 130.251Z"
          fill="#F5F5F5"
        />
        <path
          d="M98.2404 294.667C105.398 294.667 111.204 288.861 111.204 281.703C111.204 274.542 105.398 268.736 98.2404 268.736C91.0804 268.736 85.2734 274.542 85.2734 281.703C85.2734 288.861 91.0804 294.667 98.2404 294.667Z"
          fill="#FAFAFA"
        />
        <path
          d="M98.2404 261.371C103.983 261.371 108.64 256.715 108.64 250.968C108.64 245.225 103.983 240.569 98.2404 240.569C92.4944 240.569 87.8384 245.225 87.8384 250.968C87.8384 256.715 92.4944 261.371 98.2404 261.371Z"
          fill="#FAFAFA"
        />
        <path
          d="M98.2401 298.042C90.2911 298.042 83.8481 304.484 83.8481 312.43C83.8481 320.382 90.2911 326.823 98.2401 326.823C106.187 326.823 112.631 320.382 112.631 312.43C112.631 304.484 106.187 298.042 98.2401 298.042Z"
          fill="#FAFAFA"
        />
        <path
          d="M98.2402 396.148C93.5562 396.148 89.7612 399.948 89.7612 404.63C89.7612 409.313 93.5562 413.107 98.2402 413.107C102.922 413.107 106.713 409.313 106.713 404.63C106.713 399.948 102.922 396.148 98.2402 396.148Z"
          fill="#FAFAFA"
        />
        <path
          d="M36.7754 268.096C29.2624 268.096 23.1704 274.186 23.1704 281.704C23.1704 289.218 29.2624 295.313 36.7754 295.313C44.2904 295.313 50.3834 289.218 50.3834 281.704C50.3834 274.186 44.2904 268.096 36.7754 268.096Z"
          fill="#FAFAFA"
        />
        <path
          d="M36.7753 264.505C44.2503 264.505 50.3123 258.449 50.3123 250.969C50.3123 243.492 44.2503 237.435 36.7753 237.435C29.3003 237.435 23.2363 243.492 23.2363 250.969C23.2363 258.449 29.3003 264.505 36.7753 264.505Z"
          fill="#FAFAFA"
        />
        <path
          d="M36.7751 170.243C43.1131 170.243 48.2451 165.107 48.2451 158.774C48.2451 152.44 43.1131 147.304 36.7751 147.304C30.4411 147.304 25.3071 152.44 25.3071 158.774C25.3071 165.107 30.4411 170.243 36.7751 170.243Z"
          fill="#FAFAFA"
        />
        <path
          d="M36.7754 70.1406C38.7434 70.1406 40.3364 68.5496 40.3364 66.5796C40.3364 64.6136 38.7434 63.0176 36.7754 63.0176C34.8104 63.0176 33.2134 64.6136 33.2134 66.5796C33.2134 68.5496 34.8104 70.1406 36.7754 70.1406Z"
          fill="#FAFAFA"
        />
        <path
          d="M36.775 37.8743C37.895 37.8743 38.802 36.9673 38.802 35.8483C38.802 34.7283 37.895 33.8223 36.775 33.8223C35.657 33.8223 34.75 34.7283 34.75 35.8483C34.75 36.9673 35.657 37.8743 36.775 37.8743Z"
          fill="#FAFAFA"
        />
        <path
          d="M36.7751 232.56C43.5821 232.56 49.0991 227.046 49.0991 220.236C49.0991 213.432 43.5821 207.911 36.7751 207.911C29.9691 207.911 24.4531 213.432 24.4531 220.236C24.4531 227.046 29.9691 232.56 36.7751 232.56Z"
          fill="#F5F5F5"
        />
        <path
          d="M36.7752 201.332C43.3062 201.332 48.6022 196.038 48.6022 189.511C48.6022 182.978 43.3062 177.684 36.7752 177.684C30.2442 177.684 24.9482 182.978 24.9482 189.511C24.9482 196.038 30.2442 201.332 36.7752 201.332Z"
          fill="#FAFAFA"
        />
        <path
          d="M36.7754 138.228C42.4014 138.228 46.9624 133.67 46.9624 128.041C46.9624 122.418 42.4014 117.854 36.7754 117.854C31.1504 117.854 26.5884 122.418 26.5884 128.041C26.5884 133.67 31.1504 138.228 36.7754 138.228Z"
          fill="#FAFAFA"
        />
        <path
          d="M6.04245 302.243C0.41945 302.243 -4.14355 306.806 -4.14355 312.43C-4.14355 318.06 0.41945 322.617 6.04245 322.617C11.6694 322.617 16.2334 318.06 16.2334 312.43C16.2334 306.806 11.6694 302.243 6.04245 302.243Z"
          fill="#FAFAFA"
        />
        <path
          d="M6.04222 367.842C2.69722 367.842 -0.00878906 370.548 -0.00878906 373.898C-0.00878906 377.244 2.69722 379.95 6.04222 379.95C9.38822 379.95 12.1002 377.244 12.1002 373.898C12.1002 370.548 9.38822 367.842 6.04222 367.842Z"
          fill="#F5F5F5"
        />
        <path
          d="M36.7751 104.006C40.4731 104.006 43.4731 101.013 43.4731 97.3102C43.4731 93.6132 40.4731 90.6152 36.7751 90.6152C33.0771 90.6152 30.0801 93.6132 30.0801 97.3102C30.0801 101.013 33.0771 104.006 36.7751 104.006Z"
          fill="#FAFAFA"
        />
        <path
          d="M6.04335 268.166C-1.43265 268.166 -7.49365 274.229 -7.49365 281.703C-7.49365 289.173 -1.43265 295.237 6.04335 295.237C13.5184 295.237 19.5813 289.173 19.5813 281.703C19.5813 274.229 13.5184 268.166 6.04335 268.166Z"
          fill="#FAFAFA"
        />
        <path
          d="M67.5081 169.746C73.5651 169.746 78.4781 164.836 78.4781 158.774C78.4781 152.717 73.5651 147.807 67.5081 147.807C61.4501 147.807 56.5371 152.717 56.5371 158.774C56.5371 164.836 61.4501 169.746 67.5081 169.746Z"
          fill="#F5F5F5"
        />
        <path
          d="M67.5081 137.303C72.6231 137.303 76.7671 133.162 76.7671 128.041C76.7671 122.926 72.6231 118.779 67.5081 118.779C62.3941 118.779 58.2451 122.926 58.2451 128.041C58.2451 133.162 62.3941 137.303 67.5081 137.303Z"
          fill="#FAFAFA"
        />
        <path
          d="M67.5084 208.837C61.2114 208.837 56.1074 213.946 56.1074 220.236C56.1074 226.53 61.2114 231.635 67.5084 231.635C73.8014 231.635 78.9044 226.53 78.9044 220.236C78.9044 213.946 73.8014 208.837 67.5084 208.837Z"
          fill="#FAFAFA"
        />
        <path
          d="M67.5081 69.5718C69.1621 69.5718 70.5001 68.2288 70.5001 66.5788C70.5001 64.9278 69.1621 63.5898 67.5081 63.5898C65.8541 63.5898 64.5151 64.9278 64.5151 66.5788C64.5151 68.2288 65.8541 69.5718 67.5081 69.5718Z"
          fill="#FAFAFA"
        />
        <path
          d="M6.04335 334.901C1.48035 334.901 -2.22266 338.599 -2.22266 343.167C-2.22266 347.73 1.48035 351.427 6.04335 351.427C10.6084 351.427 14.3083 347.73 14.3083 343.167C14.3083 338.599 10.6084 334.901 6.04335 334.901Z"
          fill="#F5F5F5"
        />
        <path
          d="M67.5082 201.19C73.9612 201.19 79.1922 195.962 79.1922 189.51C79.1922 183.052 73.9612 177.823 67.5082 177.823C61.0532 177.823 55.8252 183.052 55.8252 189.51C55.8252 195.962 61.0532 201.19 67.5082 201.19Z"
          fill="#FAFAFA"
        />
        <path
          d="M36.7751 367.344C33.1561 367.344 30.2231 370.277 30.2231 373.897C30.2231 377.519 33.1561 380.453 36.7751 380.453C40.3971 380.453 43.3291 377.519 43.3291 373.897C43.3291 370.277 40.3971 367.344 36.7751 367.344Z"
          fill="#FAFAFA"
        />
        <path
          d="M67.5082 103.221C70.7722 103.221 73.4222 100.574 73.4222 97.3104C73.4222 94.0464 70.7722 91.3994 67.5082 91.3994C64.2412 91.3994 61.5942 94.0464 61.5942 97.3104C61.5942 100.574 64.2412 103.221 67.5082 103.221Z"
          fill="#FAFAFA"
        />
        <path
          d="M36.7753 334.187C31.8163 334.187 27.8003 338.21 27.8003 343.168C27.8003 348.126 31.8163 352.142 36.7753 352.142C41.7363 352.142 45.7543 348.126 45.7543 343.168C45.7543 338.21 41.7363 334.187 36.7753 334.187Z"
          fill="#F5F5F5"
        />
        <path
          d="M36.7753 301.107C30.5163 301.107 25.4453 306.178 25.4453 312.43C25.4453 318.689 30.5163 323.759 36.7753 323.759C43.0313 323.759 48.1033 318.689 48.1033 312.43C48.1033 306.178 43.0313 301.107 36.7753 301.107Z"
          fill="#F5F5F5"
        />
        <path
          d="M620.677 227.933C624.926 227.933 628.374 224.49 628.374 220.236C628.374 215.986 624.926 212.544 620.677 212.544C616.428 212.544 612.986 215.986 612.986 220.236C612.986 224.49 616.428 227.933 620.677 227.933Z"
          fill="#E5E5E5"
        />
        <path
          d="M589.945 37.6991C590.968 37.6991 591.797 36.8701 591.797 35.8481C591.797 34.8241 590.968 33.9971 589.945 33.9971C588.923 33.9971 588.095 34.8241 588.095 35.8481C588.095 36.8701 588.923 37.6991 589.945 37.6991Z"
          fill="#FAFAFA"
        />
        <path
          d="M589.945 70.4275C592.074 70.4275 593.794 68.7065 593.794 66.5795C593.794 64.4515 592.074 62.7305 589.945 62.7305C587.824 62.7305 586.098 64.4515 586.098 66.5795C586.098 68.7065 587.824 70.4275 589.945 70.4275Z"
          fill="#FAFAFA"
        />
        <path
          d="M589.945 101.298C592.149 101.298 593.934 99.5133 593.934 97.3103C593.934 95.1073 592.149 93.3213 589.945 93.3213C587.743 93.3213 585.957 95.1073 585.957 97.3103C585.957 99.5133 587.743 101.298 589.945 101.298Z"
          fill="#C89A77"
        />
        <path
          d="M589.945 124.48C587.981 124.48 586.384 126.076 586.384 128.041C586.384 130.012 587.981 131.603 589.945 131.603C591.916 131.603 593.512 130.012 593.512 128.041C593.512 126.076 591.916 124.48 589.945 124.48Z"
          fill="#E5E5E5"
        />
        <path
          d="M559.215 399.287C556.264 399.287 553.872 401.68 553.872 404.629C553.872 407.58 556.264 409.973 559.215 409.973C562.165 409.973 564.557 407.58 564.557 404.629C564.557 401.68 562.165 399.287 559.215 399.287Z"
          fill="#FAFAFA"
        />
        <path
          d="M559.214 365.704C554.689 365.704 551.026 369.373 551.026 373.898C551.026 378.423 554.689 382.089 559.214 382.089C563.739 382.089 567.409 378.423 567.409 373.898C567.409 369.373 563.739 365.704 559.214 365.704Z"
          fill="#FAFAFA"
        />
        <path
          d="M559.215 432.537C557.658 432.537 556.39 433.805 556.39 435.362C556.39 436.917 557.658 438.179 559.215 438.179C560.771 438.179 562.039 436.917 562.039 435.362C562.039 433.805 560.771 432.537 559.215 432.537Z"
          fill="#FAFAFA"
        />
        <path
          d="M589.945 163.407C592.506 163.407 594.58 161.332 594.58 158.773C594.58 156.218 592.506 154.146 589.945 154.146C587.39 154.146 585.318 156.218 585.318 158.773C585.318 161.332 587.39 163.407 589.945 163.407Z"
          fill="#A8573E"
        />
        <path
          d="M559.215 333.977C554.143 333.977 550.024 338.09 550.024 343.168C550.024 348.239 554.143 352.354 559.215 352.354C564.292 352.354 568.406 348.239 568.406 343.168C568.406 338.09 564.292 333.977 559.215 333.977Z"
          fill="#F5F5F5"
        />
        <path
          d="M559.214 321.481C564.211 321.481 568.265 317.432 568.265 312.43C568.265 307.439 564.211 303.384 559.214 303.384C554.218 303.384 550.169 307.439 550.169 312.43C550.169 317.432 554.218 321.481 559.214 321.481Z"
          fill="#F5F5F5"
        />
        <path
          d="M589.945 364.924C584.987 364.924 580.97 368.941 580.97 373.897C580.97 378.851 584.987 382.872 589.945 382.872C594.905 382.872 598.926 378.851 598.926 373.897C598.926 368.941 594.905 364.924 589.945 364.924Z"
          fill="#FAFAFA"
        />
        <path
          d="M589.945 333.332C584.517 333.332 580.116 337.733 580.116 343.167C580.116 348.597 584.517 352.997 589.945 352.997C595.375 352.997 599.775 348.597 599.775 343.167C599.775 337.733 595.375 333.332 589.945 333.332Z"
          fill="#FAFAFA"
        />
        <path
          d="M589.945 195.777C593.41 195.777 596.218 192.968 596.218 189.51C596.218 186.045 593.41 183.236 589.945 183.236C586.488 183.236 583.678 186.045 583.678 189.51C583.678 192.968 586.488 195.777 589.945 195.777Z"
          fill="#50818A"
        />
        <path
          d="M589.945 271.729C584.441 271.729 579.97 276.193 579.97 281.703C579.97 287.21 584.441 291.674 589.945 291.674C595.457 291.674 599.922 287.21 599.922 281.703C599.922 276.193 595.457 271.729 589.945 271.729Z"
          fill="#F5F5F5"
        />
        <path
          d="M589.945 321.763C595.104 321.763 599.284 317.589 599.284 312.431C599.284 307.278 595.104 303.098 589.945 303.098C584.793 303.098 580.613 307.278 580.613 312.431C580.613 317.589 584.793 321.763 589.945 321.763Z"
          fill="#F5F5F5"
        />
        <path
          d="M589.945 229.925C595.299 229.925 599.635 225.59 599.635 220.237C599.635 214.888 595.299 210.553 589.945 210.553C584.598 210.553 580.257 214.888 580.257 220.237C580.257 225.59 584.598 229.925 589.945 229.925Z"
          fill="#F5F5F5"
        />
        <path
          d="M589.945 431.582C587.862 431.582 586.173 433.277 586.173 435.361C586.173 437.444 587.862 439.139 589.945 439.139C592.034 439.139 593.724 437.444 593.724 435.361C593.724 433.277 592.034 431.582 589.945 431.582Z"
          fill="#FAFAFA"
        />
        <path
          d="M589.945 240.282C584.046 240.282 579.261 245.068 579.261 250.968C579.261 256.872 584.046 261.658 589.945 261.658C595.847 261.658 600.635 256.872 600.635 250.968C600.635 245.068 595.847 240.282 589.945 240.282Z"
          fill="#F5F5F5"
        />
        <path
          d="M589.945 398.146C586.362 398.146 583.462 401.047 583.462 404.629C583.462 408.207 586.362 411.115 589.945 411.115C593.529 411.115 596.432 408.207 596.432 404.629C596.432 401.047 593.529 398.146 589.945 398.146Z"
          fill="#FAFAFA"
        />
        <path
          d="M559.215 271.939C553.823 271.939 549.455 276.312 549.455 281.703C549.455 287.09 553.823 291.464 559.215 291.464C564.607 291.464 568.974 287.09 568.974 281.703C568.974 276.312 564.607 271.939 559.215 271.939Z"
          fill="#F5F5F5"
        />
        <path
          d="M528.484 271.3C522.74 271.3 518.084 275.956 518.084 281.703C518.084 287.447 522.74 292.103 528.484 292.103C534.231 292.103 538.887 287.447 538.887 281.703C538.887 275.956 534.231 271.3 528.484 271.3Z"
          fill="#E5E5E5"
        />
        <path
          d="M528.484 260.591C533.798 260.591 538.101 256.282 538.101 250.968C538.101 245.657 533.798 241.354 528.484 241.354C523.174 241.354 518.864 245.657 518.864 250.968C518.864 256.282 523.174 260.591 528.484 260.591Z"
          fill="#F5F5F5"
        />
        <path
          d="M528.484 211.689C523.763 211.689 519.937 215.515 519.937 220.236C519.937 224.961 523.763 228.789 528.484 228.789C533.203 228.789 537.035 224.961 537.035 220.236C537.035 215.515 533.203 211.689 528.484 211.689Z"
          fill="#E5E5E5"
        />
        <path
          d="M528.484 433.435C527.417 433.435 526.555 434.296 526.555 435.362C526.555 436.429 527.417 437.29 528.484 437.29C529.549 437.29 530.411 436.429 530.411 435.362C530.411 434.296 529.549 433.435 528.484 433.435Z"
          fill="#FAFAFA"
        />
        <path
          d="M528.484 365.843C524.034 365.843 520.434 369.449 520.434 373.898C520.434 378.342 524.034 381.947 528.484 381.947C532.931 381.947 536.532 378.342 536.532 373.898C536.532 369.449 532.931 365.843 528.484 365.843Z"
          fill="#F5F5F5"
        />
        <path
          d="M528.484 399.358C525.571 399.358 523.211 401.718 523.211 404.629C523.211 407.542 525.571 409.902 528.484 409.902C531.395 409.902 533.755 407.542 533.755 404.629C533.755 401.718 531.395 399.358 528.484 399.358Z"
          fill="#FAFAFA"
        />
        <path
          d="M528.484 90.3281C524.629 90.3281 521.5 93.4561 521.5 97.3101C521.5 101.17 524.629 104.293 528.484 104.293C532.337 104.293 535.465 101.17 535.465 97.3101C535.465 93.4561 532.337 90.3281 528.484 90.3281Z"
          fill="#F5F5F5"
        />
        <path
          d="M559.215 240.856C553.629 240.856 549.099 245.381 549.099 250.968C549.099 256.558 553.629 261.084 559.215 261.084C564.8 261.084 569.33 256.558 569.33 250.968C569.33 245.381 564.8 240.856 559.215 240.856Z"
          fill="#E5E5E5"
        />
        <path
          d="M528.484 167.465C533.285 167.465 537.176 163.574 537.176 158.773C537.176 153.972 533.285 150.08 528.484 150.08C523.681 150.08 519.791 153.972 519.791 158.773C519.791 163.574 523.681 167.465 528.484 167.465Z"
          fill="#E5E5E5"
        />
        <path
          d="M528.484 180.888C523.719 180.888 519.866 184.747 519.866 189.511C519.866 194.268 523.719 198.129 528.484 198.129C533.246 198.129 537.105 194.268 537.105 189.511C537.105 184.747 533.246 180.888 528.484 180.888Z"
          fill="#243C2F"
        />
        <path
          d="M528.484 135.739C532.732 135.739 536.18 132.291 536.18 128.042C536.18 123.794 532.732 120.351 528.484 120.351C524.235 120.351 520.791 123.794 520.791 128.042C520.791 132.291 524.235 135.739 528.484 135.739Z"
          fill="#6A835E"
        />
        <path
          d="M559.215 165.832C563.111 165.832 566.268 162.671 566.268 158.774C566.268 154.882 563.111 151.727 559.215 151.727C555.322 151.727 552.161 154.882 552.161 158.774C552.161 162.671 555.322 165.832 559.215 165.832Z"
          fill="#C89A77"
        />
        <path
          d="M559.214 197.195C563.464 197.195 566.912 193.753 566.912 189.51C566.912 185.255 563.464 181.813 559.214 181.813C554.965 181.813 551.523 185.255 551.523 189.51C551.523 193.753 554.965 197.195 559.214 197.195Z"
          fill="#F5F5F5"
        />
        <path
          d="M528.484 334.333C523.606 334.333 519.65 338.284 519.65 343.167C519.65 348.043 523.606 352.001 528.484 352.001C533.361 352.001 537.318 348.043 537.318 343.167C537.318 338.284 533.361 334.333 528.484 334.333Z"
          fill="#F5F5F5"
        />
        <path
          d="M559.214 229.286C564.211 229.286 568.265 225.232 568.265 220.236C568.265 215.24 564.211 211.19 559.214 211.19C554.218 211.19 550.169 215.24 550.169 220.236C550.169 225.232 554.218 229.286 559.214 229.286Z"
          fill="#E5E5E5"
        />
        <path
          d="M559.215 133.742C562.365 133.742 564.913 131.192 564.913 128.041C564.913 124.896 562.365 122.342 559.215 122.342C556.069 122.342 553.516 124.896 553.516 128.041C553.516 131.192 556.069 133.742 559.215 133.742Z"
          fill="#A8573E"
        />
        <path
          d="M528.484 302.391C522.935 302.391 518.438 306.882 518.438 312.431C518.438 317.979 522.935 322.478 528.484 322.478C534.032 322.478 538.529 317.979 538.529 312.431C538.529 306.882 534.032 302.391 528.484 302.391Z"
          fill="#F5F5F5"
        />
        <path
          d="M559.215 71.8506C562.126 71.8506 564.486 69.4906 564.486 66.5796C564.486 63.6676 562.126 61.3076 559.215 61.3076C556.303 61.3076 553.942 63.6676 553.942 66.5796C553.942 69.4906 556.303 71.8506 559.215 71.8506Z"
          fill="#F5F5F5"
        />
        <path
          d="M559.215 102.653C562.165 102.653 564.557 100.26 564.557 97.3098C564.557 94.3598 562.165 91.9678 559.215 91.9678C556.264 91.9678 553.872 94.3598 553.872 97.3098C553.872 100.26 556.264 102.653 559.215 102.653Z"
          fill="#50818A"
        />
        <path
          d="M559.215 39.2696C561.103 39.2696 562.635 37.7376 562.635 35.8486C562.635 33.9586 561.103 32.4326 559.215 32.4326C557.325 32.4326 555.794 33.9586 555.794 35.8486C555.794 37.7376 557.325 39.2696 559.215 39.2696Z"
          fill="#FAFAFA"
        />
        <path
          d="M620.677 272.086C615.367 272.086 611.059 276.394 611.059 281.703C611.059 287.013 615.367 291.323 620.677 291.323C625.994 291.323 630.296 287.013 630.296 281.703C630.296 276.394 625.994 272.086 620.677 272.086Z"
          fill="#F5F5F5"
        />
        <path
          d="M712.878 430.588C710.241 430.588 708.102 432.725 708.102 435.361C708.102 437.998 710.241 440.129 712.878 440.129C715.512 440.129 717.645 437.998 717.645 435.361C717.645 432.725 715.512 430.588 712.878 430.588Z"
          fill="#FAFAFA"
        />
        <path
          d="M712.878 408.977C715.275 408.977 717.218 407.027 717.218 404.629C717.218 402.226 715.275 400.283 712.878 400.283C710.474 400.283 708.53 402.226 708.53 404.629C708.53 407.027 710.474 408.977 712.878 408.977Z"
          fill="#FAFAFA"
        />
        <path
          d="M712.878 368.127C709.688 368.127 707.102 370.711 707.102 373.897C707.102 377.081 709.688 379.669 712.878 379.669C716.06 379.669 718.647 377.081 718.647 373.897C718.647 370.711 716.06 368.127 712.878 368.127Z"
          fill="#FAFAFA"
        />
        <path
          d="M682.145 333.619C676.868 333.619 672.598 337.894 672.598 343.167C672.598 348.439 676.868 352.71 682.145 352.71C687.418 352.71 691.688 348.439 691.688 343.167C691.688 337.894 687.418 333.619 682.145 333.619Z"
          fill="#FAFAFA"
        />
        <path
          d="M682.145 367.624C678.681 367.624 675.872 370.434 675.872 373.898C675.872 377.362 678.681 380.166 682.145 380.166C685.604 380.166 688.413 377.362 688.413 373.898C688.413 370.434 685.604 367.624 682.145 367.624Z"
          fill="#FAFAFA"
        />
        <path
          d="M620.677 193.281C622.762 193.281 624.456 191.594 624.456 189.51C624.456 187.421 622.762 185.731 620.677 185.731C618.592 185.731 616.905 187.421 616.905 189.51C616.905 191.594 618.592 193.281 620.677 193.281Z"
          fill="#243C2F"
        />
        <path
          d="M682.145 291.604C687.613 291.604 692.045 287.17 692.045 281.703C692.045 276.232 687.613 271.799 682.145 271.799C676.673 271.799 672.24 276.232 672.24 281.703C672.24 287.17 676.673 291.604 682.145 291.604Z"
          fill="#F5F5F5"
        />
        <path
          d="M682.145 258.166C686.118 258.166 689.339 254.945 689.339 250.968C689.339 247 686.118 243.774 682.145 243.774C678.167 243.774 674.946 247 674.946 250.968C674.946 254.945 678.167 258.166 682.145 258.166Z"
          fill="#F5F5F5"
        />
        <path
          d="M712.878 333.689C707.643 333.689 703.4 337.934 703.4 343.167C703.4 348.396 707.643 352.639 712.878 352.639C718.106 352.639 722.35 348.396 722.35 343.167C722.35 337.934 718.106 333.689 712.878 333.689Z"
          fill="#FAFAFA"
        />
        <path
          d="M682.145 401.918C680.646 401.918 679.434 403.136 679.434 404.63C679.434 406.123 680.646 407.331 682.145 407.331C683.639 407.331 684.853 406.123 684.853 404.63C684.853 403.136 683.639 401.918 682.145 401.918Z"
          fill="#FAFAFA"
        />
        <path
          d="M712.878 228.571C717.478 228.571 721.208 224.842 721.208 220.236C721.208 215.635 717.478 211.899 712.878 211.899C708.27 211.899 704.536 215.635 704.536 220.236C704.536 224.842 708.27 228.571 712.878 228.571Z"
          fill="#F5F5F5"
        />
        <path
          d="M712.878 324.902C719.762 324.902 725.343 319.321 725.343 312.431C725.343 305.546 719.762 299.971 712.878 299.971C705.986 299.971 700.405 305.546 700.405 312.431C700.405 319.321 705.986 324.902 712.878 324.902Z"
          fill="#FAFAFA"
        />
        <path
          d="M712.878 260.591C718.182 260.591 722.49 256.282 722.49 250.968C722.49 245.657 718.182 241.354 712.878 241.354C707.561 241.354 703.253 245.657 703.253 250.968C703.253 256.282 707.561 260.591 712.878 260.591Z"
          fill="#F5F5F5"
        />
        <path
          d="M712.878 293.46C719.367 293.46 724.628 288.194 724.628 281.703C724.628 275.209 719.367 269.947 712.878 269.947C706.382 269.947 701.12 275.209 701.12 281.703C701.12 288.194 706.382 293.46 712.878 293.46Z"
          fill="#F5F5F5"
        />
        <path
          d="M712.878 196.488C716.731 196.488 719.854 193.364 719.854 189.51C719.854 185.65 716.731 182.527 712.878 182.527C709.018 182.527 705.894 185.65 705.894 189.51C705.894 193.364 709.018 196.488 712.878 196.488Z"
          fill="#E5E5E5"
        />
        <path
          d="M712.878 100.234C714.491 100.234 715.795 98.9247 715.795 97.3107C715.795 95.6977 714.491 94.3877 712.878 94.3877C711.259 94.3877 709.954 95.6977 709.954 97.3107C709.954 98.9247 711.259 100.234 712.878 100.234Z"
          fill="#F5F5F5"
        />
        <path
          d="M712.878 165.187C716.418 165.187 719.285 162.314 719.285 158.773C719.285 155.239 716.418 152.364 712.878 152.364C709.337 152.364 706.464 155.239 706.464 158.773C706.464 162.314 709.337 165.187 712.878 165.187Z"
          fill="#F5F5F5"
        />
        <path
          d="M712.878 68.5759C713.976 68.5759 714.868 67.6829 714.868 66.5789C714.868 65.4739 713.976 64.5869 712.878 64.5869C711.773 64.5869 710.881 65.4739 710.881 66.5789C710.881 67.6829 711.773 68.5759 712.878 68.5759Z"
          fill="#F5F5F5"
        />
        <path
          d="M712.878 133.097C715.67 133.097 717.933 130.835 717.933 128.041C717.933 125.248 715.67 122.986 712.878 122.986C710.084 122.986 707.815 125.248 707.815 128.041C707.815 130.835 710.084 133.097 712.878 133.097Z"
          fill="#F5F5F5"
        />
        <path
          d="M682.145 301.247C675.964 301.247 670.956 306.254 670.956 312.43C670.956 318.605 675.964 323.618 682.145 323.618C688.322 323.618 693.329 318.605 693.329 312.43C693.329 306.254 688.322 301.247 682.145 301.247Z"
          fill="#F5F5F5"
        />
        <path
          d="M620.677 333.835C615.524 333.835 611.345 338.014 611.345 343.167C611.345 348.32 615.524 352.498 620.677 352.498C625.836 352.498 630.014 348.32 630.014 343.167C630.014 338.014 625.836 333.835 620.677 333.835Z"
          fill="#F5F5F5"
        />
        <path
          d="M620.677 365.347C615.958 365.347 612.13 369.179 612.13 373.899C612.13 378.619 615.958 382.445 620.677 382.445C625.397 382.445 629.23 378.619 629.23 373.899C629.23 369.179 625.397 365.347 620.677 365.347Z"
          fill="#FAFAFA"
        />
        <path
          d="M620.677 303.028C615.486 303.028 611.276 307.239 611.276 312.43C611.276 317.626 615.486 321.837 620.677 321.837C625.872 321.837 630.084 317.626 630.084 312.43C630.084 307.239 625.872 303.028 620.677 303.028Z"
          fill="#F5F5F5"
        />
        <path
          d="M651.409 258.095C655.348 258.095 658.538 254.907 658.538 250.968C658.538 247.038 655.348 243.843 651.409 243.843C647.474 243.843 644.286 247.038 644.286 250.968C644.286 254.907 647.474 258.095 651.409 258.095Z"
          fill="#F5F5F5"
        />
        <path
          d="M651.409 191.928C652.751 191.928 653.834 190.841 653.834 189.51C653.834 188.167 652.751 187.085 651.409 187.085C650.071 187.085 648.989 188.167 648.989 189.51C648.989 190.841 650.071 191.928 651.409 191.928Z"
          fill="#E5E5E5"
        />
        <path
          d="M651.409 225.08C654.088 225.08 656.254 222.917 656.254 220.237C656.254 217.563 654.088 215.392 651.409 215.392C648.735 215.392 646.564 217.563 646.564 220.237C646.564 222.917 648.735 225.08 651.409 225.08Z"
          fill="#F5F5F5"
        />
        <path
          d="M620.677 260.375C625.872 260.375 630.084 256.163 630.084 250.968C630.084 245.777 625.872 241.57 620.677 241.57C615.486 241.57 611.276 245.777 611.276 250.968C611.276 256.163 615.486 260.375 620.677 260.375Z"
          fill="#F5F5F5"
        />
        <path
          d="M620.677 431.658C618.632 431.658 616.975 433.315 616.975 435.361C616.975 437.408 618.632 439.063 620.677 439.063C622.724 439.063 624.385 437.408 624.385 435.361C624.385 433.315 622.724 431.658 620.677 431.658Z"
          fill="#FAFAFA"
        />
        <path
          d="M528.484 73.7021C532.417 73.7021 535.607 70.5141 535.607 66.5791C535.607 62.6431 532.417 59.4551 528.484 59.4551C524.548 59.4551 521.36 62.6431 521.36 66.5791C521.36 70.5141 524.548 73.7021 528.484 73.7021Z"
          fill="#F5F5F5"
        />
        <path
          d="M620.677 398.075C617.057 398.075 614.123 401.009 614.123 404.629C614.123 408.245 617.057 411.184 620.677 411.184C624.299 411.184 627.233 408.245 627.233 404.629C627.233 401.009 624.299 398.075 620.677 398.075Z"
          fill="#FAFAFA"
        />
        <path
          d="M682.145 129.611C683.006 129.611 683.71 128.908 683.71 128.042C683.71 127.176 683.006 126.478 682.145 126.478C681.279 126.478 680.577 127.176 680.577 128.042C680.577 128.908 681.279 129.611 682.145 129.611Z"
          fill="#50818A"
        />
        <path
          d="M682.145 225.795C685.21 225.795 687.699 223.305 687.699 220.237C687.699 217.174 685.21 214.683 682.145 214.683C679.071 214.683 676.586 217.174 676.586 220.237C676.586 223.305 679.071 225.795 682.145 225.795Z"
          fill="#E5E5E5"
        />
        <path
          d="M682.145 161.199C683.483 161.199 684.566 160.116 684.566 158.774C684.566 157.436 683.483 156.354 682.145 156.354C680.803 156.354 679.721 157.436 679.721 158.774C679.721 160.116 680.803 161.199 682.145 161.199Z"
          fill="#243C2F"
        />
        <path
          d="M651.409 291.036C656.568 291.036 660.745 286.858 660.745 281.703C660.745 276.547 656.568 272.367 651.409 272.367C646.256 272.367 642.078 276.547 642.078 281.703C642.078 286.858 646.256 291.036 651.409 291.036Z"
          fill="#FAFAFA"
        />
        <path
          d="M651.409 333.758C646.218 333.758 642.007 337.976 642.007 343.167C642.007 348.358 646.218 352.569 651.409 352.569C656.605 352.569 660.816 348.358 660.816 343.167C660.816 337.976 656.605 333.758 651.409 333.758Z"
          fill="#FAFAFA"
        />
        <path
          d="M682.145 193.213C684.193 193.213 685.848 191.552 685.848 189.511C685.848 187.464 684.193 185.803 682.145 185.803C680.099 185.803 678.438 187.464 678.438 189.511C678.438 191.552 680.099 193.213 682.145 193.213Z"
          fill="#6A835E"
        />
        <path
          d="M651.409 302.032C645.665 302.032 641.01 306.692 641.01 312.43C641.01 318.179 645.665 322.834 651.409 322.834C657.158 322.834 661.812 318.179 661.812 312.43C661.812 306.692 657.158 302.032 651.409 302.032Z"
          fill="#F5F5F5"
        />
        <path
          d="M651.409 366.559C647.361 366.559 644.074 369.846 644.074 373.899C644.074 377.948 647.361 381.233 651.409 381.233C655.463 381.233 658.748 377.948 658.748 373.899C658.748 369.846 655.463 366.559 651.409 366.559Z"
          fill="#FAFAFA"
        />
        <path
          d="M651.409 400.424C649.092 400.424 647.208 402.308 647.208 404.63C647.208 406.947 649.092 408.83 651.409 408.83C653.731 408.83 655.615 406.947 655.615 404.63C655.615 402.308 653.731 400.424 651.409 400.424Z"
          fill="#FAFAFA"
        />
        <path
          d="M651.409 433.435C650.348 433.435 649.488 434.301 649.488 435.362C649.488 436.424 650.348 437.284 651.409 437.284C652.475 437.284 653.335 436.424 653.335 435.362C653.335 434.301 652.475 433.435 651.409 433.435Z"
          fill="#FAFAFA"
        />
        <path
          d="M344.092 270.728C338.035 270.728 333.123 275.642 333.123 281.704C333.123 287.761 338.035 292.677 344.092 292.677C350.15 292.677 355.066 287.761 355.066 281.704C355.066 275.642 350.15 270.728 344.092 270.728Z"
          fill="#E5E5E5"
        />
        <path
          d="M405.557 75.7697C410.635 75.7697 414.748 71.6557 414.748 66.5797C414.748 61.5017 410.635 57.3887 405.557 57.3887C400.48 57.3887 396.367 61.5017 396.367 66.5797C396.367 71.6557 400.48 75.7697 405.557 75.7697Z"
          fill="#E5E5E5"
        />
        <path
          d="M405.557 141.65C413.07 141.65 419.165 135.561 419.165 128.042C419.165 120.529 413.07 114.434 405.557 114.434C398.044 114.434 391.949 120.529 391.949 128.042C391.949 135.561 398.044 141.65 405.557 141.65Z"
          fill="#243C2F"
        />
        <path
          d="M405.557 108.92C411.971 108.92 417.171 103.724 417.171 97.3102C417.171 90.8952 411.971 85.6992 405.557 85.6992C399.143 85.6992 393.946 90.8952 393.946 97.3102C393.946 103.724 399.143 108.92 405.557 108.92Z"
          fill="#50818A"
        />
        <path
          d="M405.557 204.682C413.936 204.682 420.73 197.889 420.73 189.51C420.73 181.125 413.936 174.331 405.557 174.331C397.178 174.331 390.38 181.125 390.38 189.51C390.38 197.889 397.178 204.682 405.557 204.682Z"
          fill="#C89A77"
        />
        <path
          d="M405.557 173.522C413.704 173.522 420.305 166.92 420.305 158.773C420.305 150.631 413.704 144.029 405.557 144.029C397.414 144.029 390.81 150.631 390.81 158.773C390.81 166.92 397.414 173.522 405.557 173.522Z"
          fill="#E5E5E5"
        />
        <path
          d="M405.557 204.923C397.097 204.923 390.24 211.775 390.24 220.236C390.24 228.696 397.097 235.553 405.557 235.553C414.018 235.553 420.872 228.696 420.872 220.236C420.872 211.775 414.018 204.923 405.557 204.923Z"
          fill="#50818A"
        />
        <path
          d="M374.825 270.516C368.649 270.516 363.638 275.524 363.638 281.704C363.638 287.88 368.649 292.888 374.825 292.888C381.005 292.888 386.012 287.88 386.012 281.704C386.012 275.524 381.005 270.516 374.825 270.516Z"
          fill="#243C2F"
        />
        <path
          d="M405.557 6.89596C406.541 6.89596 407.338 6.10096 407.338 5.11596C407.338 4.13096 406.541 3.33496 405.557 3.33496C404.572 3.33496 403.777 4.13096 403.777 5.11596C403.777 6.10096 404.572 6.89596 405.557 6.89596Z"
          fill="#A8573E"
        />
        <path
          d="M374.825 237.36C367.312 237.36 361.218 243.455 361.218 250.968C361.218 258.485 367.312 264.58 374.825 264.58C382.338 264.58 388.433 258.485 388.433 250.968C388.433 243.455 382.338 237.36 374.825 237.36Z"
          fill="#E5E5E5"
        />
        <path
          d="M405.557 40.4757C408.115 40.4757 410.188 38.4077 410.188 35.8487C410.188 33.2877 408.115 31.2207 405.557 31.2207C403 31.2207 400.927 33.2877 400.927 35.8487C400.927 38.4077 403 40.4757 405.557 40.4757Z"
          fill="#C89A77"
        />
        <path
          d="M436.289 9.32204C438.611 9.32204 440.495 7.43804 440.495 5.11604C440.495 2.79304 438.611 0.915039 436.289 0.915039C433.966 0.915039 432.086 2.79304 432.086 5.11604C432.086 7.43804 433.966 9.32204 436.289 9.32204Z"
          fill="#E5E5E5"
        />
        <path
          d="M405.557 369.411C403.078 369.411 401.071 371.418 401.071 373.897C401.071 376.378 403.078 378.385 405.557 378.385C408.037 378.385 410.044 376.378 410.044 373.897C410.044 371.418 408.037 369.411 405.557 369.411Z"
          fill="#E5E5E5"
        />
        <path
          d="M436.289 77.8372C442.502 77.8372 447.545 72.7972 447.545 66.5792C447.545 60.3642 442.502 55.3252 436.289 55.3252C430.072 55.3252 425.032 60.3642 425.032 66.5792C425.032 72.7972 430.072 77.8372 436.289 77.8372Z"
          fill="#C89A77"
        />
        <path
          d="M436.289 43.6848C440.616 43.6848 444.126 40.1768 444.126 35.8478C444.126 31.5168 440.616 28.0088 436.289 28.0088C431.962 28.0088 428.453 31.5168 428.453 35.8478C428.453 40.1768 431.962 43.6848 436.289 43.6848Z"
          fill="#A8573E"
        />
        <path
          d="M405.557 237.008C397.843 237.008 391.593 243.26 391.593 250.968C391.593 258.68 397.843 264.932 405.557 264.932C413.268 264.932 419.522 258.68 419.522 250.968C419.522 243.26 413.268 237.008 405.557 237.008Z"
          fill="#F5F5F5"
        />
        <path
          d="M436.289 109.634C443.095 109.634 448.614 104.119 448.614 97.3103C448.614 90.5053 443.095 84.9854 436.289 84.9854C429.483 84.9854 423.963 90.5053 423.963 97.3103C423.963 104.119 429.483 109.634 436.289 109.634Z"
          fill="#6A835E"
        />
        <path
          d="M405.557 270.089C399.143 270.089 393.946 275.29 393.946 281.703C393.946 288.118 399.143 293.314 405.557 293.314C411.971 293.314 417.171 288.118 417.171 281.703C417.171 275.29 411.971 270.089 405.557 270.089Z"
          fill="#E5E5E5"
        />
        <path
          d="M405.557 336.396C401.818 336.396 398.787 339.427 398.787 343.167C398.787 346.902 401.818 349.934 405.557 349.934C409.297 349.934 412.325 346.902 412.325 343.167C412.325 339.427 409.297 336.396 405.557 336.396Z"
          fill="#F5F5F5"
        />
        <path
          d="M405.557 402.702C404.496 402.702 403.633 403.57 403.633 404.63C403.633 405.691 404.496 406.551 405.557 406.551C406.617 406.551 407.482 405.691 407.482 404.63C407.482 403.57 406.617 402.702 405.557 402.702Z"
          fill="#E5E5E5"
        />
        <path
          d="M405.557 303.384C400.559 303.384 396.51 307.439 396.51 312.43C396.51 317.432 400.559 321.481 405.557 321.481C410.553 321.481 414.604 317.432 414.604 312.43C414.604 307.439 410.553 303.384 405.557 303.384Z"
          fill="#243C2F"
        />
        <path
          d="M374.825 305.453C370.969 305.453 367.843 308.576 367.843 312.43C367.843 316.29 370.969 319.413 374.825 319.413C378.68 319.413 381.809 316.29 381.809 312.43C381.809 308.576 378.68 305.453 374.825 305.453Z"
          fill="#A8573E"
        />
        <path
          d="M344.092 306.021C340.555 306.021 337.682 308.895 337.682 312.43C337.682 315.975 340.555 318.844 344.092 318.844C347.634 318.844 350.504 315.975 350.504 312.43C350.504 308.895 347.634 306.021 344.092 306.021Z"
          fill="#50818A"
        />
        <path
          d="M344.092 239C337.486 239 332.127 244.357 332.127 250.968C332.127 257.581 337.486 262.94 344.092 262.94C350.704 262.94 356.061 257.581 356.061 250.968C356.061 244.357 350.704 239 344.092 239Z"
          fill="#243C2F"
        />
        <path
          d="M344.092 146.519C337.326 146.519 331.84 152.008 331.84 158.774C331.84 165.54 337.326 171.028 344.092 171.028C350.861 171.028 356.348 165.54 356.348 158.774C356.348 152.008 350.861 146.519 344.092 146.519Z"
          fill="#A8573E"
        />
        <path
          d="M344.092 178.181C337.836 178.181 332.765 183.248 332.765 189.511C332.765 195.763 337.836 200.834 344.092 200.834C350.348 200.834 355.423 195.763 355.423 189.511C355.423 183.248 350.348 178.181 344.092 178.181Z"
          fill="#F5F5F5"
        />
        <path
          d="M374.825 73.2738C378.523 73.2738 381.521 70.2748 381.521 66.5788C381.521 62.8808 378.523 59.8828 374.825 59.8828C371.129 59.8828 368.127 62.8808 368.127 66.5788C368.127 70.2748 371.129 73.2738 374.825 73.2738Z"
          fill="#6A835E"
        />
        <path
          d="M344.092 209.48C338.151 209.48 333.334 214.298 333.334 220.236C333.334 226.179 338.151 230.997 344.092 230.997C350.034 230.997 354.85 226.179 354.85 220.236C354.85 214.298 350.034 209.48 344.092 209.48Z"
          fill="#E5E5E5"
        />
        <path
          d="M528.484 7.96453C530.058 7.96453 531.335 6.68653 531.335 5.11653C531.335 3.54253 530.058 2.26953 528.484 2.26953C526.907 2.26953 525.636 3.54253 525.636 5.11653C525.636 6.68653 526.907 7.96453 528.484 7.96453Z"
          fill="#F5F5F5"
        />
        <path
          d="M346.941 373.898C346.941 372.324 345.67 371.045 344.092 371.045C342.52 371.045 341.247 372.324 341.247 373.898C341.247 375.474 342.52 376.745 344.092 376.745C345.67 376.745 346.941 375.474 346.941 373.898Z"
          fill="#C89A77"
        />
        <path
          d="M347.324 343.171C347.324 341.385 345.882 339.934 344.092 339.934C342.308 339.934 340.864 341.385 340.864 343.171C340.864 344.961 342.308 346.403 344.092 346.403C345.882 346.403 347.324 344.961 347.324 343.171Z"
          fill="#A8573E"
        />
        <path
          d="M374.825 206.061C366.998 206.061 360.649 212.409 360.649 220.237C360.649 228.069 366.998 234.417 374.825 234.417C382.653 234.417 389.001 228.069 389.001 220.237C389.001 212.409 382.653 206.061 374.825 206.061Z"
          fill="#243C2F"
        />
        <path
          d="M374.825 401.993C373.37 401.993 372.189 403.174 372.189 404.629C372.189 406.081 373.37 407.266 374.825 407.266C376.283 407.266 377.461 406.081 377.461 404.629C377.461 403.174 376.283 401.993 374.825 401.993Z"
          fill="#F5F5F5"
        />
        <path
          d="M374.825 339.173C372.623 339.173 370.836 340.958 370.836 343.167C370.836 345.365 372.623 347.15 374.825 347.15C377.029 347.15 378.814 345.365 378.814 343.167C378.814 340.958 377.029 339.173 374.825 339.173Z"
          fill="#243C2F"
        />
        <path
          d="M374.825 37.7688C375.886 37.7688 376.748 36.9078 376.748 35.8478C376.748 34.7858 375.886 33.9258 374.825 33.9258C373.766 33.9258 372.904 34.7858 372.904 35.8478C372.904 36.9078 373.766 37.7688 374.825 37.7688Z"
          fill="#F5F5F5"
        />
        <path
          d="M374.825 370.904C373.172 370.904 371.831 372.248 371.831 373.897C371.831 375.55 373.172 376.892 374.825 376.892C376.476 376.892 377.815 375.55 377.815 373.897C377.815 372.248 376.476 370.904 374.825 370.904Z"
          fill="#E5E5E5"
        />
        <path
          d="M374.825 107.994C380.724 107.994 385.51 103.209 385.51 97.31C385.51 91.41 380.724 86.625 374.825 86.625C368.925 86.625 364.138 91.41 364.138 97.31C364.138 103.209 368.925 107.994 374.825 107.994Z"
          fill="#A8573E"
        />
        <path
          d="M374.825 140.94C381.947 140.94 387.72 135.164 387.72 128.041C387.72 120.924 381.947 115.148 374.825 115.148C367.705 115.148 361.932 120.924 361.932 128.041C361.932 135.164 367.705 140.94 374.825 140.94Z"
          fill="#C89A77"
        />
        <path
          d="M374.825 172.667C382.495 172.667 388.717 166.448 388.717 158.773C388.717 151.103 382.495 144.883 374.825 144.883C367.152 144.883 360.932 151.103 360.932 158.773C360.932 166.448 367.152 172.667 374.825 172.667Z"
          fill="#F5F5F5"
        />
        <path
          d="M374.825 203.468C382.536 203.468 388.788 197.218 388.788 189.51C388.788 181.797 382.536 175.539 374.825 175.539C367.113 175.539 360.861 181.797 360.861 189.51C360.861 197.218 367.113 203.468 374.825 203.468Z"
          fill="#6A835E"
        />
        <path
          d="M467.02 171.953C474.3 171.953 480.201 166.053 480.201 158.773C480.201 151.493 474.3 145.592 467.02 145.592C459.74 145.592 453.84 151.493 453.84 158.773C453.84 166.053 459.74 171.953 467.02 171.953Z"
          fill="#243C2F"
        />
        <path
          d="M497.752 43.9666C502.238 43.9666 505.875 40.3346 505.875 35.8486C505.875 31.3606 502.238 27.7236 497.752 27.7236C493.267 27.7236 489.633 31.3606 489.633 35.8486C489.633 40.3346 493.267 43.9666 497.752 43.9666Z"
          fill="#F5F5F5"
        />
        <path
          d="M497.752 76.2676C503.105 76.2676 507.44 71.9317 507.44 66.5797C507.44 61.2257 503.105 56.8896 497.752 56.8896C492.401 56.8896 488.065 61.2257 488.065 66.5797C488.065 71.9317 492.401 76.2676 497.752 76.2676Z"
          fill="#F5F5F5"
        />
        <path
          d="M497.752 107.286C503.262 107.286 507.727 102.82 507.727 97.3098C507.727 91.7988 503.262 87.3398 497.752 87.3398C492.247 87.3398 487.775 91.7988 487.775 97.3098C487.775 102.82 492.247 107.286 497.752 107.286Z"
          fill="#E5E5E5"
        />
        <path
          d="M497.752 138.299C503.419 138.299 508.008 133.709 508.008 128.041C508.008 122.379 503.419 117.783 497.752 117.783C492.085 117.783 487.496 122.379 487.496 128.041C487.496 133.709 492.085 138.299 497.752 138.299Z"
          fill="#243C2F"
        />
        <path
          d="M497.752 9.81497C500.349 9.81497 502.456 7.70897 502.456 5.11597C502.456 2.51797 500.349 0.417969 497.752 0.417969C495.156 0.417969 493.052 2.51797 493.052 5.11597C493.052 7.70897 495.156 9.81497 497.752 9.81497Z"
          fill="#F5F5F5"
        />
        <path
          d="M497.752 169.961C503.927 169.961 508.94 164.948 508.94 158.773C508.94 152.597 503.927 147.59 497.752 147.59C491.575 147.59 486.566 152.597 486.566 158.773C486.566 164.948 491.575 169.961 497.752 169.961Z"
          fill="#F5F5F5"
        />
        <path
          d="M467.02 269.022C460.018 269.022 454.34 274.699 454.34 281.703C454.34 288.708 460.018 294.381 467.02 294.381C474.025 294.381 479.702 288.708 479.702 281.703C479.702 274.699 474.025 269.022 467.02 269.022Z"
          fill="#F5F5F5"
        />
        <path
          d="M467.02 301.107C460.763 301.107 455.693 306.178 455.693 312.43C455.693 318.689 460.763 323.759 467.02 323.759C473.278 323.759 478.348 318.689 478.348 312.43C478.348 306.178 473.278 301.107 467.02 301.107Z"
          fill="#F5F5F5"
        />
        <path
          d="M467.02 206.704C459.545 206.704 453.484 212.765 453.484 220.236C453.484 227.711 459.545 233.774 467.02 233.774C474.495 233.774 480.558 227.711 480.558 220.236C480.558 212.765 474.495 206.704 467.02 206.704Z"
          fill="#F5F5F5"
        />
        <path
          d="M467.02 237.863C459.783 237.863 453.914 243.73 453.914 250.968C453.914 258.21 459.783 264.077 467.02 264.077C474.262 264.077 480.13 258.21 480.13 250.968C480.13 243.73 474.262 237.863 467.02 237.863Z"
          fill="#E5E5E5"
        />
        <path
          d="M497.752 333.901C492.637 333.901 488.49 338.051 488.49 343.167C488.49 348.282 492.637 352.429 497.752 352.429C502.866 352.429 507.012 348.282 507.012 343.167C507.012 338.051 502.866 333.901 497.752 333.901Z"
          fill="#F5F5F5"
        />
        <path
          d="M497.752 301.179C491.537 301.179 486.496 306.217 486.496 312.431C486.496 318.65 491.537 323.69 497.752 323.69C503.966 323.69 509.011 318.65 509.011 312.431C509.011 306.217 503.966 301.179 497.752 301.179Z"
          fill="#F5F5F5"
        />
        <path
          d="M436.29 141.369C443.648 141.369 449.61 135.398 449.61 128.042C449.61 120.686 443.648 114.722 436.29 114.722C428.932 114.722 422.964 120.686 422.964 128.042C422.964 135.398 428.932 141.369 436.29 141.369Z"
          fill="#F5F5F5"
        />
        <path
          d="M497.752 200.834C504.009 200.834 509.08 195.763 509.08 189.511C509.08 183.248 504.009 178.181 497.752 178.181C491.497 178.181 486.422 183.248 486.422 189.511C486.422 195.763 491.497 200.834 497.752 200.834Z"
          fill="#A8573E"
        />
        <path
          d="M528.484 41.7646C531.752 41.7646 534.395 39.1126 534.395 35.8486C534.395 32.5836 531.752 29.9316 528.484 29.9316C525.219 29.9316 522.572 32.5836 522.572 35.8486C522.572 39.1126 525.219 41.7646 528.484 41.7646Z"
          fill="#FAFAFA"
        />
        <path
          d="M497.752 262.583C504.166 262.583 509.363 257.382 509.363 250.968C509.363 244.554 504.166 239.357 497.752 239.357C491.34 239.357 486.141 244.554 486.141 250.968C486.141 257.382 491.34 262.583 497.752 262.583Z"
          fill="#E5E5E5"
        />
        <path
          d="M497.752 269.661C491.105 269.661 485.713 275.052 485.713 281.703C485.713 288.351 491.105 293.742 497.752 293.742C504.399 293.742 509.789 288.351 509.789 281.703C509.789 275.052 504.399 269.661 497.752 269.661Z"
          fill="#E5E5E5"
        />
        <path
          d="M497.752 398.433C494.331 398.433 491.554 401.203 491.554 404.63C491.554 408.051 494.331 410.828 497.752 410.828C501.179 410.828 503.95 408.051 503.95 404.63C503.95 401.203 501.179 398.433 497.752 398.433Z"
          fill="#F5F5F5"
        />
        <path
          d="M497.752 365.493C493.107 365.493 489.346 369.255 489.346 373.897C489.346 378.538 493.107 382.305 497.752 382.305C502.396 382.305 506.158 378.538 506.158 373.897C506.158 369.255 502.396 365.493 497.752 365.493Z"
          fill="#F5F5F5"
        />
        <path
          d="M497.752 209.124C491.613 209.124 486.638 214.103 486.638 220.236C486.638 226.373 491.613 231.354 497.752 231.354C503.889 231.354 508.864 226.373 508.864 220.236C508.864 214.103 503.889 209.124 497.752 209.124Z"
          fill="#6A835E"
        />
        <path
          d="M436.289 269.374C429.483 269.374 423.963 274.899 423.963 281.703C423.963 288.508 429.483 294.029 436.289 294.029C443.095 294.029 448.614 288.508 448.614 281.703C448.614 274.899 443.095 269.374 436.289 269.374Z"
          fill="#E5E5E5"
        />
        <path
          d="M436.289 334.545C431.525 334.545 427.671 338.404 427.671 343.167C427.671 347.926 431.525 351.783 436.289 351.783C441.049 351.783 444.909 347.926 444.909 343.167C444.909 338.404 441.049 334.545 436.289 334.545Z"
          fill="#E5E5E5"
        />
        <path
          d="M436.289 301.604C430.308 301.604 425.46 306.455 425.46 312.43C425.46 318.416 430.308 323.261 436.289 323.261C442.269 323.261 447.12 318.416 447.12 312.43C447.12 306.455 442.269 301.604 436.289 301.604Z"
          fill="#E5E5E5"
        />
        <path
          d="M436.289 204.992C427.87 204.992 421.043 211.819 421.043 220.236C421.043 228.659 427.87 235.484 436.289 235.484C444.711 235.484 451.533 228.659 451.533 220.236C451.533 211.819 444.711 204.992 436.289 204.992Z"
          fill="#A8573E"
        />
        <path
          d="M467.02 10.5989C470.051 10.5989 472.509 8.14693 472.509 5.11593C472.509 2.08393 470.051 -0.37207 467.02 -0.37207C463.991 -0.37207 461.534 2.08393 461.534 5.11593C461.534 8.14693 463.991 10.5989 467.02 10.5989Z"
          fill="#F5F5F5"
        />
        <path
          d="M436.289 237.293C428.733 237.293 422.611 243.417 422.611 250.968C422.611 258.523 428.733 264.645 436.289 264.645C443.845 264.645 449.967 258.523 449.967 250.968C449.967 243.417 443.845 237.293 436.289 237.293Z"
          fill="#243C2F"
        />
        <path
          d="M436.289 401.42C434.519 401.42 433.085 402.855 433.085 404.63C433.085 406.394 434.519 407.834 436.289 407.834C438.059 407.834 439.493 406.394 439.493 404.63C439.493 402.855 438.059 401.42 436.289 401.42Z"
          fill="#F5F5F5"
        />
        <path
          d="M436.289 173.454C444.396 173.454 450.966 166.883 450.966 158.774C450.966 150.67 444.396 144.099 436.289 144.099C428.185 144.099 421.614 150.67 421.614 158.774C421.614 166.883 428.185 173.454 436.289 173.454Z"
          fill="#50818A"
        />
        <path
          d="M436.289 174.115C427.791 174.115 420.9 181.012 420.9 189.51C420.9 198.002 427.791 204.892 436.289 204.892C444.786 204.892 451.676 198.002 451.676 189.51C451.676 181.012 444.786 174.115 436.289 174.115Z"
          fill="#243C2F"
        />
        <path
          d="M436.289 367.624C432.825 367.624 430.018 370.434 430.018 373.898C430.018 377.362 432.825 380.166 436.289 380.166C439.75 380.166 442.56 377.362 442.56 373.898C442.56 370.434 439.75 367.624 436.289 367.624Z"
          fill="#E5E5E5"
        />
        <path
          d="M467.02 399.071C463.954 399.071 461.463 401.561 461.463 404.629C461.463 407.7 463.954 410.189 467.02 410.189C470.089 410.189 472.58 407.7 472.58 404.629C472.58 401.561 470.089 399.071 467.02 399.071Z"
          fill="#F5F5F5"
        />
        <path
          d="M467.02 175.687C459.388 175.687 453.2 181.872 453.2 189.511C453.2 197.137 459.388 203.329 467.02 203.329C474.652 203.329 480.844 197.137 480.844 189.511C480.844 181.872 474.652 175.687 467.02 175.687Z"
          fill="#E5E5E5"
        />
        <path
          d="M467.02 140.084C473.67 140.084 479.065 134.688 479.065 128.041C479.065 121.394 473.67 116.003 467.02 116.003C460.373 116.003 454.981 121.394 454.981 128.041C454.981 134.688 460.373 140.084 467.02 140.084Z"
          fill="#A8573E"
        />
        <path
          d="M467.02 333.977C461.945 333.977 457.829 338.09 457.829 343.168C457.829 348.239 461.945 352.354 467.02 352.354C472.098 352.354 476.211 348.239 476.211 343.168C476.211 338.09 472.098 333.977 467.02 333.977Z"
          fill="#E5E5E5"
        />
        <path
          d="M467.02 365.992C462.654 365.992 459.111 369.53 459.111 373.898C459.111 378.261 462.654 381.802 467.02 381.802C471.389 381.802 474.927 378.261 474.927 373.898C474.927 369.53 471.389 365.992 467.02 365.992Z"
          fill="#F5F5F5"
        />
        <path
          d="M467.02 77.5504C473.08 77.5504 477.991 72.6404 477.991 66.5794C477.991 60.5224 473.08 55.6074 467.02 55.6074C460.963 55.6074 456.048 60.5224 456.048 66.5794C456.048 72.6404 460.963 77.5504 467.02 77.5504Z"
          fill="#F5F5F5"
        />
        <path
          d="M467.02 108.996C473.472 108.996 478.704 103.768 478.704 97.3099C478.704 90.8579 473.472 85.6289 467.02 85.6289C460.568 85.6289 455.336 90.8579 455.336 97.3099C455.336 103.768 460.568 108.996 467.02 108.996Z"
          fill="#243C2F"
        />
        <path
          d="M467.02 44.611C471.859 44.611 475.784 40.686 475.784 35.848C475.784 31.008 471.859 27.083 467.02 27.083C462.181 27.083 458.257 31.008 458.257 35.848C458.257 40.686 462.181 44.611 467.02 44.611Z"
          fill="#F5F5F5"
        />
      </svg>
    </div>
  )
}
